import { render, staticRenderFns } from "./JumbotronView.vue?vue&type=template&id=f1d36148&scoped=true"
import script from "./JumbotronView.vue?vue&type=script&lang=js"
export * from "./JumbotronView.vue?vue&type=script&lang=js"
import style0 from "./JumbotronView.vue?vue&type=style&index=0&id=f1d36148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d36148",
  null
  
)

export default component.exports